import type { Class } from "@/types";
import { CHARACTER_CLASSES } from "@/constants";

export const spellcrafter: Class = {
  name: "Spellcrafter",
  id: CHARACTER_CLASSES.SPELLCRAFTER,
  classType: CHARACTER_CLASSES.MAGIC_USER,
  description:
    "Spellcrafters are special magicians who are subclass of Magic-Users. They have the same abilities as Magic-Users but with unique focuses on spell creation and modification.",
  hitDie: "1d4",
  primaryAttribute: "intelligence",
  abilityRequirements: [
    {
      ability: "intelligence",
      min: 9,
    },
  ],
  allowedWeapons: ["dagger", "walking-staff"],
  allowedArmor: ["none"],
  spellcasting: {
    spellsPerLevel: {
      1: [1],
      2: [2],
      3: [2, 1],
      4: [2, 2],
      5: [2, 2, 1],
      6: [3, 2, 2],
      7: [3, 2, 2, 1],
      8: [3, 3, 2, 2],
      9: [3, 3, 2, 2, 1],
      10: [4, 3, 3, 2, 2],
      11: [4, 4, 3, 2, 2, 1],
      12: [4, 4, 3, 3, 2, 2],
      13: [4, 4, 4, 3, 2, 2],
      14: [4, 4, 4, 3, 3, 2],
      15: [5, 4, 4, 3, 3, 2],
      16: [5, 5, 4, 3, 3, 2],
      17: [5, 5, 4, 4, 3, 3],
      18: [6, 5, 4, 4, 3, 3],
      19: [6, 5, 5, 4, 3, 3],
      20: [6, 5, 5, 4, 4, 3],
    },
  },
  specialAbilities: [
    {
      name: "Read Magic",
      description:
        "A first level Spellcrafter begins play knowing read magic and one other spell of first level. Read magic is so ingrained that a Spellcrafter can prepare it without a spellbook.",
    },
    {
      name: "Magic Item Bonuses",
      description:
        "Spellcrafters receive a bonus of +1 to all saving throws made against effects generated by magic items. Those who are targets of magical effects generated by a magic item operated by a Spellcrafter suffer a penalty of -1 on any saving throw against it.",
    },
    {
      name: "Scroll Creation (1st Level)",
      description:
        "Spellcrafters can create any scroll starting at 1st level. They receive a +25% bonus to all magical research rolls for creating magical items.",
    },
    {
      name: "Potion & Item Creation (3rd Level)",
      description:
        "Beginning at 3rd level, Spellcrafters can create potions and other single use magic items.",
    },
    {
      name: "Advanced Magic Item Creation (7th Level)",
      description:
        "At 7th level, Spellcrafters can create any kind of magic item.",
    },
    {
      name: "Accelerated Crafting (6th Level)",
      description:
        "At 6th level, Spellcrafters become so adept as to cut in half the time necessary to create a magic item.",
    },
    {
      name: "Cost Reduction (9th Level)",
      description:
        "At 9th level, Spellcrafters become so adept as to reduce the cost of creating a magic item by 25%.",
    },
  ],
  experienceTable: {
    1: 0,
    2: 2500,
    3: 5000,
    4: 10000,
    5: 20000,
    6: 40000,
    7: 80000,
    8: 150000,
    9: 300000,
    10: 450000,
    11: 600000,
    12: 750000,
    13: 900000,
    14: 1050000,
    15: 1200000,
    16: 1350000,
    17: 1500000,
    18: 1650000,
    19: 1800000,
    20: 1950000,
  },
  supplementalContent: true,
};
